<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Show Case</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Create New</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <b-card class="text-center bg-gray-100">
            <b-row>
              <b-col>
                <img v-show="!file" v-if="items.image" width="100%" :src="items.image" />
                <img v-show="file" v-if="url" width="100%" :src="url" />
              </b-col>
            </b-row>
            <input
              type="file"
              ref="file"
              style="display: none"
              v-validate="'image|minimalDimensions:720,500|size:2000|ext:jpg,png,gif,jpeg'"
              name="image"
              @change="onChangeFileUpload()"
            />
            <br />
            <b-link
              @click="$refs.file.click()"
              v-show="!file && !items.image"
              variant="primary"
              class="text-primary btn"
            >
              <img class="mr-2" src="@/assets/ic-plus.svg" alt /> Select Image Here
              <label class="text-danger">*</label>
            </b-link>
            <b-button
              @click="$refs.file.click()"
              v-show="file || items.image"
              variant="outline-primary"
              class
            >
              <img class="mr-2" src="@/assets/ic-edit.svg" alt /> Edit
            </b-button>
            <br />
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('image') }}</p>
            <p class="text-gray-500">
              Ukuran gambar 720x500 pixel
              File gambar harus berupa format JPEG, PNG, atau GIF
              Gambar tidak boleh melebihi 2MB
            </p>
          </b-card>
          <br />
          <label class="text-danger">
            *
            <b class="text-dark">Required</b>
          </label>
        </b-col>

        <b-col md="8">
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Title Bahasa"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  type="text"
                  class="form-control"
                  v-validate="'required|max:25'"
                  name="title_id"
                  data-vv-as="Title Bahasa"
                  v-model="items.title.id"
                  placeholder="Title"
                />
                <b-form-invalid-feedback
                  id="input-title_id-feedback"
                >{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Title English"
                label-for="input-1"
              >
                <input
                  id="input-1"
                  type="text"
                  class="form-control"
                  v-validate="'required|max:25'"
                  name="title_en"
                  data-vv-as="Title English"
                  v-model="items.title.en"
                  placeholder="Title"
                />
                <b-form-invalid-feedback
                  id="input-title_en-feedback"
                >{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Content Bahasa"
                label-for="input-1"
              >
                <ckeditor
                  :editor="editor"
                  :config="editorConfig"
                  v-model="items.content.id"
                  v-validate="'required|max:200'"
                  name="content_id"
                  data-vv-as="Content Bahasa"
                  tag-name="textarea"
                  placeholder="Content Bahasa"
                  class="form-control"
                ></ckeditor>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('content_id') }}</p>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Content English"
                label-for="input-1"
              >
                <ckeditor
                  :editor="editor"
                  :config="editorConfig"
                  v-model="items.content.en"
                  v-validate="'required|max:200'"
                  name="content_en"
                  data-vv-as="Content English"
                  tag-name="textarea"
                  placeholder="Content English"
                  class="form-control"
                ></ckeditor>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('content_en') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col class="text-center" v-if="newuser_availability != null">
              <div class="text-success" style="width:100%;margin-top:.25rem;font-size: 80%;">
                <label>{{newuser_availability.message}}</label>
                <label v-for="message in newuser_availability.data" :key="message">{{message}}</label>
              </div>
            </b-col>
            <b-col class="text-center" v-else-if="error_availability != null">
              <div class="text-danger" style="width:100%;margin-top:.25rem;font-size: 80%;">
                <label>{{error_availability.message}}</label>
                <label v-for="message in error_availability.data" :key="message">{{message}}</label>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="fieldset-1" label="Start Date" label-for="input-1">
                <b-row class="m-0">
                  <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      @input="getShowCaseAvailability()"
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="items.periode.start_date"
                      :format="customFormatter"
                      :disabledDates="disabledDates"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetStardate" style="text-decoration:none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="fieldset-1" label="End Date" label-for="input-1">
                <b-row class="m-0">
                  <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="2">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      @input="getShowCaseAvailability()"
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="items.periode.end_date"
                      :format="customFormatter"
                      :disabledDates="disabledDates"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetEnddate" style="text-decoration:none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
                <b-row></b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col>
              <b-button
                variant="primary"
                @click="put()"
                :disabled="loading || error_availability != null"
                class="mr-5"
              >Save</b-button>
              <b-button
                variant="warning"
                @click="modalShow = !modalShow"
                :disabled="!file && !items.image"
                class="mr-5"
              >Preview</b-button>
              <router-link :to="{name: 'ShowCase'}">
                <b-button variant="outline-secondary">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
          <b-modal v-model="modalShow" hide-footer hide-header title="Preview Image">
            <b-row>
              <b-col>
                <h5 class="font-weight-bold text-dark">Preview</h5>
              </b-col>
            </b-row>
            <br />
            <b-card
              v-show="file"
              overlay
              :img-src="url"
              img-alt="Card Image"
              style="max-width: 100%;"
              v-if="url"
              text-variant="white"
            >
              <b-card-text>
                <h1 style="margin-top:35%;">{{items.title.id}}</h1>
                <h6 v-html="items.content.id"></h6>
              </b-card-text>
            </b-card>
            <b-card
              v-show="!file"
              v-if="items.image"
              overlay
              :img-src="items.image"
              img-alt="Card Image"
              style="max-width: 100%;"
              text-variant="white"
            >
              <b-card-text>
                <h1 style="margin-top:35%;">{{items.title.id}}</h1>
                <h6 v-html="items.content.id"></h6>
              </b-card-text>
            </b-card>
            <br />
            <b-row>
              <b-col align="right">
                <b-button class="py-1 px-4" @click="modalShow=false" variant="outline-primary">OK</b-button>
              </b-col>
            </b-row>
          </b-modal>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      loading: false,
      selected: "first",
      checked: false,
      modalShow: false,
      file: "",
      widthImage: null,
      heightImage: null,
      url: "",
      items: [],
      slide_screen: [],
      disabledDates: {
        to: new Date(Date.now() - 8672000)
      },
      newuser_availability: null,
      error_availability: null
    };
  },
  beforeCreate() {
    this.$store
      .dispatch("ShowCaseModule/getShowCase", this.$route.params.id)
      .then(response => {
        this.loading = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loading = false;
      });
    const formData = new FormData();
    formData.append("period_start", "");
    formData.append("period_end", "");
    formData.append("showcase_id", this.$route.params.id);
    this.$store
      .dispatch("ShowCaseModule/getShowCaseAvailabilityEdit", formData)
      .then(response => {
        this.newuser_availability = response.data;
      })
      .catch(error => {
        this.error_availability = error.response.data;
      });
  },
  created() {
    this.$store.watch(
      state => state.ShowCaseModule.showcase_id,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    getShowCaseAvailability() {
      const formData = new FormData();
      if (
        this.items.periode.start_date == "" &&
        this.items.periode.end_date != ""
      ) {
        const endDate = moment(this.items.periode.end_date).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", this.items.periode.start_date);
        formData.append("period_end", endDate);
      }
      if (
        this.items.periode.start_date != "" &&
        this.items.periode.end_date == ""
      ) {
        const startDate = moment(this.items.periode.start_date).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", startDate);
        formData.append("period_end", this.items.periode.end_date);
      }
      if (
        this.items.periode.start_date != "" &&
        this.items.periode.end_date != ""
      ) {
        const startDate = moment(this.items.periode.start_date).format(
          "YYYY-MM-DD"
        );
        const endDate = moment(this.items.periode.end_date).format(
          "YYYY-MM-DD"
        );

        formData.append("period_start", startDate);
        formData.append("period_end", endDate);
      }
      if (
        this.items.periode.start_date == "" &&
        this.items.periode.end_date == ""
      ) {
        formData.append("period_start", this.items.periode.start_date);
        formData.append("period_end", this.items.periode.end_date);
      }
      formData.append("showcase_id", this.$route.params.id);
      this.$store
        .dispatch("ShowCaseModule/getShowCaseAvailabilityEdit", formData)
        .then(response => {
          this.newuser_availability = response.data;
          this.error_availability = null;
        })
        .catch(error => {
          this.newuser_availability = null;
          this.error_availability = error.response.data;
        });
    },
    resetStardate() {
      const formData = new FormData();
      if (
        this.items.periode.start_date == "" &&
        this.items.periode.end_date != ""
      ) {
        const endDate = moment(this.items.periode.end_date).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", this.items.periode.start_date);
        formData.append("period_end", endDate);
      }
      if (
        this.items.periode.start_date != "" &&
        this.items.periode.end_date == ""
      ) {
        const startDate = moment(this.items.periode.start_date).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", startDate);
        formData.append("period_end", this.items.periode.end_date);
      }
      if (
        this.items.periode.start_date != "" &&
        this.items.periode.end_date != ""
      ) {
        const startDate = moment(this.items.periode.start_date).format(
          "YYYY-MM-DD"
        );
        const endDate = moment(this.items.periode.end_date).format(
          "YYYY-MM-DD"
        );

        formData.append("period_start", startDate);
        formData.append("period_end", endDate);
      }
      if (
        this.items.periode.start_date == "" &&
        this.items.periode.end_date == ""
      ) {
        formData.append("period_start", this.items.periode.start_date);
        formData.append("period_end", this.items.periode.end_date);
      }
      formData.append("showcase_id", this.$route.params.id);
      this.$store
        .dispatch("ShowCaseModule/getShowCaseAvailabilityEdit", formData)
        .then(response => {
          this.newuser_availability = response.data;
          this.error_availability = null;
        })
        .catch(error => {
          this.newuser_availability = null;
          this.error_availability = error.response.data;
        });
      this.items.periode.start_date = "";
    },
    resetEnddate() {
      const formData = new FormData();
      if (
        this.items.periode.start_date == "" &&
        this.items.periode.end_date != ""
      ) {
        const endDate = moment(this.items.periode.end_date).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", this.items.periode.start_date);
        formData.append("period_end", endDate);
      }
      if (
        this.items.periode.start_date != "" &&
        this.items.periode.end_date == ""
      ) {
        const startDate = moment(this.items.periode.start_date).format(
          "YYYY-MM-DD"
        );
        formData.append("period_start", startDate);
        formData.append("period_end", this.items.periode.end_date);
      }
      if (
        this.items.periode.start_date != "" &&
        this.items.periode.end_date != ""
      ) {
        const startDate = moment(this.items.periode.start_date).format(
          "YYYY-MM-DD"
        );
        const endDate = moment(this.items.periode.end_date).format(
          "YYYY-MM-DD"
        );

        formData.append("period_start", startDate);
        formData.append("period_end", endDate);
      }
      if (
        this.items.periode.start_date == "" &&
        this.items.periode.end_date == ""
      ) {
        formData.append("period_start", this.items.periode.start_date);
        formData.append("period_end", this.items.periode.end_date);
      }
      formData.append("showcase_id", this.$route.params.id);
      this.$store
        .dispatch("ShowCaseModule/getShowCaseAvailabilityEdit", formData)
        .then(response => {
          this.newuser_availability = response.data;
          this.error_availability = null;
        })
        .catch(error => {
          this.newuser_availability = null;
          this.error_availability = error.response.data;
        });
      this.items.periode.end_date = "";
    },
    put() {
      this.$swal({
        title: "Are you sure?",
        text: "You will update this Show Case!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!"
      }).then(result => {
        if (result.value) {
          this.$validator.validateAll().then(result => {
            if (result) {
              const formData = new FormData();
              formData.append("title_id", this.items.title.id);
              formData.append("title_en", this.items.title.en);
              formData.append("content_id", this.items.content.id);
              formData.append("content_en", this.items.content.en);
              formData.append("image", this.file);
              if (
                this.items.periode.start_date == "" &&
                this.items.periode.end_date != ""
              ) {
                const endDate = moment(this.items.periode.end_date).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", this.items.periode.start_date);
                formData.append("period_end", endDate);
              }
              if (
                this.items.periode.start_date != "" &&
                this.items.periode.end_date == ""
              ) {
                const startDate = moment(this.items.periode.start_date).format(
                  "YYYY-MM-DD"
                );
                formData.append("period_start", startDate);
                formData.append("period_end", this.items.periode.end_date);
              }
              if (
                this.items.periode.start_date != "" &&
                this.items.periode.end_date != ""
              ) {
                const startDate = moment(this.items.periode.start_date).format(
                  "YYYY-MM-DD"
                );
                const endDate = moment(this.items.periode.end_date).format(
                  "YYYY-MM-DD"
                );

                formData.append("period_start", startDate);
                formData.append("period_end", endDate);
              }
              if (
                this.items.periode.start_date == "" &&
                this.items.periode.end_date == ""
              ) {
                formData.append("period_start", this.items.periode.start_date);
                formData.append("period_end", this.items.periode.end_date);
              }

              this.loading = true;
              this.$store
                .dispatch("ShowCaseModule/putShowCase", {
                  id: this.$route.params.id,
                  formData
                })
                .then(response => {
                  this.loading = false;
                  this.$router.push({ name: "ShowCase" });
                  this.$swal({
                    type: "success",
                    title: "Your work has been saved",
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(response);
                })
                .catch(error => {
                  this.loading = false;
                  this.serverError = error.response.data;
                  this.$swal({
                    type: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  console.log(error);
                });
            } else {
              this.$swal("ERROR!", "Your file cant be submit.", "warning");
            }
          });
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.url = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
